import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-elements-per-page',
    templateUrl: './elements-per-page.component.html',
    styleUrls: ['./elements-per-page.component.scss'],
    standalone: false
})
export class ElementsPerPageComponent
{
  get activeOption()
  {
    return this._activeOption;
  }

  @Input() set activeOption(value)
  {
    if (value)
    {
      this._activeOption = value.toString();
    }
  }

  @Input() public numberOfElements;
  private _activeOption;
  @Output() public readonly elementsPerPage: EventEmitter<number> = new EventEmitter<number>();

  public hasElements(): number
  {
    return this.numberOfElements;
  }
}
